/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Available_To_PayoutInputs */

const en_available_to_payout = /** @type {(inputs: Available_To_PayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available to Payout`)
};

const es_available_to_payout = /** @type {(inputs: Available_To_PayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible para pagar`)
};

const fr_available_to_payout = /** @type {(inputs: Available_To_PayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible pour paiement`)
};

const de_available_to_payout = /** @type {(inputs: Available_To_PayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur Auszahlung verfügbar`)
};

const ja_available_to_payout = /** @type {(inputs: Available_To_PayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支払い可能残高`)
};

const zh_available_to_payout = /** @type {(inputs: Available_To_PayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可提现金额`)
};

const ar_available_to_payout = /** @type {(inputs: Available_To_PayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متاح للسحب`)
};

const id_available_to_payout = /** @type {(inputs: Available_To_PayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tersedia untuk Dicairkan`)
};

const it_available_to_payout = /** @type {(inputs: Available_To_PayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibile per il Pagamento`)
};

const ru_available_to_payout = /** @type {(inputs: Available_To_PayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступно для выплаты`)
};

const pt_available_to_payout = /** @type {(inputs: Available_To_PayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponível para Saque`)
};

const ko_available_to_payout = /** @type {(inputs: Available_To_PayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정산 가능 금액`)
};

/**
* | output |
* | --- |
* | "Available to Payout" |
*
* @param {Available_To_PayoutInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const available_to_payout = /** @type {((inputs?: Available_To_PayoutInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Available_To_PayoutInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_available_to_payout(inputs)
	if (locale === "es") return es_available_to_payout(inputs)
	if (locale === "fr") return fr_available_to_payout(inputs)
	if (locale === "de") return de_available_to_payout(inputs)
	if (locale === "ja") return ja_available_to_payout(inputs)
	if (locale === "zh") return zh_available_to_payout(inputs)
	if (locale === "ar") return ar_available_to_payout(inputs)
	if (locale === "id") return id_available_to_payout(inputs)
	if (locale === "it") return it_available_to_payout(inputs)
	if (locale === "ru") return ru_available_to_payout(inputs)
	if (locale === "pt") return pt_available_to_payout(inputs)
	return ko_available_to_payout(inputs)
});